export default "__VITE_ASSET__d02552ee__"